export enum MyTripFindTripBy {
  CONFIRMATION_NUMBER = 'confirmationNo',
  CREDIT_CARD_NUMBER = 'creditCardNo',
  TICKET_NUMBER = 'eTicketNo'
}

export const MyTripFieldTitles = {
  findTripBy: '',
  confirmationNumber: '',
  creditCardNumber: '',
  ticketNumber: '',
  skyMilesNumber: '',
  passengerLastName: '',
  passengerFirstName: ''
};

export enum TAB {
  CONFIRMATION_NO = 'confirmationNo'
}

export enum TRIP_USING {
  CONFIRMATION = 'CONFIRMATION',
  TICKET = 'TICKET',
  CREDITCARD = 'CREDITCARD',
  LOYALTYNUM = 'LOYALTYNUM'
}

export const START_FROM_MYDELTA = 'mydelta';
export const START_FROM_HOME = 'I';

export const SEARCH_TYPE = 'confirmationInput';
